<script lang="ts">
	import type { DatasheetSideBarPoiData } from '$lib/components/pois/types';
	import SideBarAd from '$lib/components/advertising/SideBarAd.svelte';
	import AccommodationAvailability from '$lib/components/pois/datasheet/accommodation-availability/AccommodationAvailability.svelte';
	import GetYourGuideRecommendations from '$lib/components/pois/datasheet/recommandations/GetYourGuideRecommendations.svelte';

	export let poi: DatasheetSideBarPoiData;

	let extraClasses = '';
	export { extraClasses as class };
</script>

<div class="flex flex-col items-start gap-4 {extraClasses}">
	{#if poi.__typename === 'AccommodationPOI'}
		{@const datasheetId = poi.datasheetId ?? undefined}
		{#key datasheetId}
			<AccommodationAvailability {datasheetId} {poi} on:selectDates on:clearDates />
		{/key}
	{:else if poi.__typename === 'TourismPOI'}
		<GetYourGuideRecommendations coordinates={poi.coordinates} on:bookClick />
	{/if}
	{#if poi.__typename !== 'AccommodationPOI'}
		<SideBarAd />
	{/if}
</div>
